import React, { useContext, useState, useEffect, useRef } from "react";
import "../Tabels/Tabels.css";
import { Link } from "react-router-dom";
import Offcanvas from "react-bootstrap/Offcanvas";
import Card from "react-bootstrap/Card";
import Select from "react-select";
import ModalSave from "../common/ModelSave";
import { CancelButton, SaveButton } from "../common/Button";
import {
  Row,
  Col,
  Form,
  Modal,
  Container,
  InputGroup,
  Button,
} from "react-bootstrap";
import { useForm, Controller, useFieldArray } from "react-hook-form";
import classNames from "classnames";
import { Context } from "../../utils/context";
import JoditEditor from "jodit-react";
import Table from "react-bootstrap/Table";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ImageValidation } from "../../utils/common";
import { ValidationImage } from "../../utils/api";
import { getallPackageDetailType } from "../../utils/apis/master/Master";

const AddOffCanvance = (props) => {
  const { postData, Select2Data, getDimension } = useContext(Context);

  const [detailType, setDetailType] = useState("");


  const getDetailTypes = async () => {
    const res = await getallPackageDetailType();

    if (res?.success) {
      setDetailType(await Select2Data(res?.data, "detail_type_id"));
    } else {
      console.error('Error fetching  data:', res?.error);
    }
  }
  useEffect(() => {
    getDetailTypes()
  }, [props]);


  const [showModal, setShowModal] = useState({
    code: 0,
    message: "",
  });

  const {
    control,
    register,
    handleSubmit,
    getValues,
    formState: { errors },
    watch,
    setValue,
    trigger,
    setError,
    clearErrors,
  } = useForm({
    defaultValues: {
      description: "",
    },
  });
  const imageFile = watch("image");

  const buildFormData = (data) => {
    const formData = new FormData();

    formData.append("name", data.name);
    formData.append("subname", data.subname);
    formData.append("description", data.description);
    formData.append("location", data.location);
    formData.append("days", data.days);
    formData.append("per_car_price", data.per_car_price);

    if (data.image && data.image[0]) {
      formData.append("image", data.image[0]);
    }

    const cleanedPackages = data.packages_detail.map((pkg) => ({
      name: pkg.name || "",
      detail_type_id: pkg.detail_type_id?.value,
      descriptions: pkg.descriptions.map((desc) => ({
        content: desc.content,
        images: desc.images.map((img) => img.preview), // optional
      })),
    }));

    formData.append("packages_detail", JSON.stringify(cleanedPackages));

    data.packages_detail.forEach((pkg, i) => {
      pkg.descriptions.forEach((desc, j) => {
        desc.images.forEach((img, k) => {
          if (img.file) {
            const originalName = img.file.name;
            const ext = originalName.split('.').pop(); // png

            const fileName = `pkg_${i}_desc_${j}_${k}.${ext}`;

            formData.append("files", img.file, fileName);
          }
        });
      });
    });

    return formData;
  };

  const getFilteredOptions = (currentIndex) => {
    const allDetails = getValues("packages_detail") ?? [];

    const selectedValues = allDetails
      .map((item, i) => i !== currentIndex ? item?.detail_type_id?.value : null)
      .filter(Boolean);

    return detailType?.filter(
      (option) => !selectedValues.includes(option.value)
    );
  };
  const {
    fields: dayFields,
    append: appendDay,
    remove: removeDay,
  } = useFieldArray({
    control,
    name: "packages_detail",
  });

  const [quantityError, setQuantityError] = useState("");
  useEffect(() => {
    register("packages_detail", {
      validate: (value) => {
        const isValid = value && value.length > 0;
        setQuantityError(isValid ? "" : "At least one Package is required");
        return isValid;
      },
    });
  }, [register]);

  useEffect(() => {
    register("description", {
      required: "Description is required.",
    });
  }, [register]);



  const onSubmit = async (data) => {

    const formData = await buildFormData(data);
    try {

      const response = await postData(`/packages`, formData);

      if (response?.success) {
        await props.setShowModal({
          code: response.code,
          message: response.message,
        });
        props.handleClose();
      } else {
        await props.setShowModal({
          code: response.code,
          message: response.message,
        });
      }
      setTimeout(() => {
        props.setShowModal({ code: 0, message: response.message });
      }, 2000);
    } catch (error) {
      console.log(error);
    }
  };


  const emptyDescription = () => ({ content: "", images: [] });


  const emptyDay = () => ({
    name: "",
    descriptions: [emptyDescription()],
    // images: [],
  });
  function DayDescriptions({ dayIndex, control, setValue, trigger, errors }) {
    const {
      fields: descFields,
      append: appendDesc,
      remove: removeDesc,
    } = useFieldArray({
      control,
      name: `packages_detail.${dayIndex}.descriptions`,
    });

    // Separate refs per description block
    const descFileRefs = useRef([]);

    const handleDescImageAdd = (descIndex, e) => {
      const files = Array.from(e.target.files);
      if (!files.length) return;

      const currentImages =
        control._formValues.packages_detail?.[dayIndex]
          ?.descriptions?.[descIndex]?.images ?? [];

      const newImages = files.map((file) => ({
        file,
        preview: URL.createObjectURL(file),
      }));

      setValue(
        `packages_detail.${dayIndex}.descriptions.${descIndex}.images`,
        [...currentImages, ...newImages],
        { shouldDirty: true }
      );
      trigger(`packages_detail.${dayIndex}.descriptions.${descIndex}.images`);
      e.target.value = "";
    };

    const handleDescImageRemove = (descIndex, imgIndex) => {
      const currentImages =
        control._formValues.packages_detail?.[dayIndex]
          ?.descriptions?.[descIndex]?.images ?? [];

      const updated = currentImages.filter((_, i) => i !== imgIndex);
      setValue(
        `packages_detail.${dayIndex}.descriptions.${descIndex}.images`,
        updated,
        { shouldDirty: true }
      );
      trigger(`packages_detail.${dayIndex}.descriptions.${descIndex}.images`);
    };

    return (
      <div className="mt-3">
        <Form.Label className="fw-semibold">
          Descriptions{" "}
          <span className="text-muted small">(one editor + images per block)</span>
        </Form.Label>

        {descFields.map((descVariant, descIndex) => (
          <div
            key={descVariant.id}
            style={{
              border: "1px solid #dee2e6",
              borderRadius: 8,
              padding: "12px 14px",
              marginBottom: 12,
              background: "#fafbfc",
            }}
          >
            {/* ── Block header ── */}
            <div className="d-flex justify-content-between align-items-center mb-2">
              <span className="text-muted small fw-semibold">
                Description {descIndex + 1}
              </span>
              {descFields.length > 1 && (
                <button
                  type="button"
                  className="btn btn-sm btn-outline-danger py-0 px-2"
                  style={{ fontSize: 12 }}
                  onClick={() => removeDesc(descIndex)}
                >
                  ✕ Remove
                </button>
              )}
            </div>

            {/* ── JoditEditor ── */}
            <Form.Group>
              <Controller
                name={`packages_detail.${dayIndex}.descriptions.${descIndex}.content`}
                control={control}
                rules={{ required: "Description is required" }}
                render={({ field }) => (
                  <JoditEditor
                    value={field.value || ""}
                    onBlur={(newContent) => {
                      setValue(
                        `packages_detail.${dayIndex}.descriptions.${descIndex}.content`,
                        newContent
                      );
                      trigger(
                        `packages_detail.${dayIndex}.descriptions.${descIndex}.content`
                      );
                    }}
                  />
                )}
              />
            </Form.Group>

            {errors?.packages_detail?.[dayIndex]?.descriptions?.[descIndex]
              ?.content && (
                <span className="text-danger small d-block mt-1">
                  {
                    errors.packages_detail[dayIndex].descriptions[descIndex]
                      .content.message
                  }
                </span>
              )}

            {/* ── Images per description ── */}
            <div className="mt-3">
              <Form.Label className="fw-semibold small">
                Images for this description block
              </Form.Label>

              {/* Hidden file input */}
              <input
                type="file"
                accept="image/*"
                multiple
                style={{ display: "none" }}
                ref={(el) => (descFileRefs.current[descIndex] = el)}
                onChange={(e) => handleDescImageAdd(descIndex, e)}
              />

              {/* Trigger button */}
              <div className="mb-2">
                <button
                  type="button"
                  className="btn btn-outline-primary btn-sm"
                  onClick={() => descFileRefs.current[descIndex]?.click()}
                >
                  + Add Images
                </button>
              </div>

              {/* Image preview grid */}
              <Controller
                name={`packages_detail.${dayIndex}.descriptions.${descIndex}.images`}
                control={control}
                defaultValue={[]}
                render={({ field }) => (
                  <>
                    {field.value && field.value.length > 0 ? (
                      <Row className="g-2 mt-1">
                        {field.value.map((img, imgIndex) => (
                          <Col
                            key={imgIndex}
                            xs={6}
                            sm={4}
                            md={3}
                            lg={2}
                            className="position-relative"
                          >
                            <div
                              style={{
                                position: "relative",
                                width: "100%",
                                paddingTop: "100%",
                                borderRadius: 8,
                                overflow: "hidden",
                                border: "1px solid #dee2e6",
                              }}
                            >
                              <img
                                src={
                                  img.preview ||
                                  (typeof img === "string" ? img : "")
                                }
                                alt={`day-${dayIndex + 1}-desc-${descIndex + 1}-img-${imgIndex + 1}`}
                                style={{
                                  position: "absolute",
                                  top: 0,
                                  left: 0,
                                  width: "100%",
                                  height: "100%",
                                  objectFit: "cover",
                                }}
                              />
                              <button
                                type="button"
                                onClick={() =>
                                  handleDescImageRemove(descIndex, imgIndex)
                                }
                                style={{
                                  position: "absolute",
                                  top: 4,
                                  right: 4,
                                  background: "rgba(220,53,69,0.85)",
                                  border: "none",
                                  borderRadius: "50%",
                                  width: 22,
                                  height: 22,
                                  color: "#fff",
                                  fontSize: 12,
                                  lineHeight: "22px",
                                  textAlign: "center",
                                  cursor: "pointer",
                                  padding: 0,
                                }}
                              >
                                ✕
                              </button>
                            </div>
                            <p
                              className="text-muted text-center mt-1"
                              style={{ fontSize: 10, wordBreak: "break-all" }}
                            >
                              {img.file?.name ?? `Image ${imgIndex + 1}`}
                            </p>
                          </Col>
                        ))}
                      </Row>
                    ) : (
                      <p className="text-muted small mt-1">
                        No images added yet.
                      </p>
                    )}
                  </>
                )}
              />

              {errors?.packages_detail?.[dayIndex]?.descriptions?.[descIndex]
                ?.images && (
                  <span className="text-danger small d-block mt-1">
                    {
                      errors.packages_detail[dayIndex].descriptions[descIndex]
                        .images.message
                    }
                  </span>
                )}
            </div>
          </div>
        ))}

        {/* ── Add another description block ── */}
        <button
          type="button"
          className="btn btn-outline-secondary btn-sm mt-1"
          onClick={() => appendDesc(emptyDescription())}
        >
          + Add Description
        </button>
      </div>
    );
  }



  return (
    <>
      <div className="prodcuttttt">
        <Offcanvas
          show={props.show}
          style={{ width: "80%" }}
          placement={"end"}
          onHide={props.handleClose}
          className="prodcuttttt-offcanvas"
        >
          <Offcanvas.Header closeButton>
            {/* <Offcanvas.Title>Add Employee</Offcanvas.Title> */}
          </Offcanvas.Header>
          <Offcanvas.Body>
            <Card className="shadow-lg p-3 mb-5  rounded">
              <Card.Body>
                <Card.Title>Add Package</Card.Title>
                <hr />
                <Container>
                  <Form
                    // onSubmit={() => handleSubmit(onSubmit)}
                    role="form"
                  // className="stateclass"
                  >
                    <Row>
                      <Col md={6}>
                        <div className="main-form-section mt-3">
                          <Row className="justify-content-center">
                            <Form.Label>Package Name</Form.Label>
                            <Form.Group>
                              <InputGroup>
                                <Form.Control
                                  type="text"
                                  name="name"
                                  placeholder="Package Name."
                                  className={classNames("", {
                                    "is-invalid": errors?.name,
                                  })}
                                  {...register("name", {
                                    required: "Package Name is required",
                                    validate: (value) =>
                                      value.length <= 200 ||
                                      "Data must be 200 characters or less",
                                  })}
                                />
                              </InputGroup>
                              {errors.name && (
                                <span className="text-danger">
                                  {errors.name.message}
                                </span>
                              )}
                            </Form.Group>
                          </Row>
                        </div>
                      </Col>
                      <Col md={6}>
                        <div className="main-form-section mt-3">
                          <Row className="justify-content-center">
                            <Form.Label>Package Sub Name</Form.Label>
                            <Form.Group>
                              <InputGroup>
                                <Form.Control
                                  type="text"
                                  name="subname"
                                  placeholder="Package subname."
                                  className={classNames("", {
                                    "is-invalid": errors?.subname,
                                  })}
                                  {...register("subname", {
                                    required: "Package subname is required",
                                    validate: (value) =>
                                      value.length <= 200 ||
                                      "Data must be 200 characters or less",
                                  })}
                                />
                              </InputGroup>
                              {errors.subname && (
                                <span className="text-danger">
                                  {errors.subname.message}
                                </span>
                              )}
                            </Form.Group>
                          </Row>
                        </div>
                      </Col>

                      <Col md={6}>
                        <div className="main-form-section mt-3">
                          <Row className="justify-content-center">
                            <Form.Label>Location</Form.Label>
                            <Form.Group>
                              <InputGroup>
                                <Form.Control
                                  type="text"
                                  name="addlocationress"
                                  placeholder="location."
                                  className={classNames("", {
                                    "is-invalid": errors?.location,
                                  })}
                                  {...register("location", {
                                    required: "location is required",
                                    validate: (value) =>
                                      value.length <= 200 ||
                                      "Data must be 200 characters or less",
                                  })}
                                />
                              </InputGroup>
                              {errors.location && (
                                <span className="text-danger">
                                  {errors.location.message}
                                </span>
                              )}
                            </Form.Group>
                          </Row>
                        </div>
                      </Col>

                      <Col md={6}>
                        <div className="main-form-section mt-3">
                          <Row className="justify-content-center">
                            <Form.Label>Days</Form.Label>
                            <Form.Group>
                              <InputGroup>
                                <Form.Control
                                  min={1}
                                  type="text"
                                  name="days"
                                  placeholder="days."
                                  className={classNames("", {
                                    "is-invalid": errors?.days,
                                  })}
                                  {...register("days", {
                                    required: "days is required",
                                    min: {
                                      value: 1,
                                      message: "Minimum Days should be at least 1",
                                    },
                                  })}
                                  onKeyDown={(e) => {
                                    if (
                                      e.key === "-" || // Prevent negative sign
                                      e.key === "+" || // Prevent plus sign
                                      e.key === "e" || // Prevent scientific notation
                                      e.key === "E" || // Prevent scientific notation
                                      e.key === "." || // Prevent decimal point (if only integers allowed)
                                      (isNaN(Number(e.key)) &&
                                        e.key !== "Backspace" &&
                                        e.key !== "Tab") // Allow only numbers, Backspace, and Tab
                                    ) {
                                      e.preventDefault();
                                    }
                                  }}
                                  onPaste={(e) => {
                                    const pasteData =
                                      e.clipboardData.getData("text");
                                    if (!/^\d+$/.test(pasteData)) {
                                      // Allow only numbers in pasted data
                                      e.preventDefault();
                                    }
                                  }}
                                />
                              </InputGroup>
                              {errors.days && (
                                <span className="text-danger">
                                  {errors.days.message}
                                </span>
                              )}
                            </Form.Group>
                          </Row>
                        </div>
                      </Col>

                      <Col md={6}>
                        <div className="main-form-section mt-3">
                          <Row className="justify-content-center">
                            <Form.Label>Per Car Price</Form.Label>
                            <Form.Group>
                              <InputGroup>
                                <Form.Control
                                  min={1}
                                  type="text"
                                  name="per_car_price"
                                  placeholder="Per Car Price."
                                  className={classNames("", {
                                    "is-invalid": errors?.per_car_price,
                                  })}
                                  {...register("per_car_price", {
                                    required: "Per Car Price is required",
                                    min: {
                                      value: 1,
                                      message: "Minimum Price should be at least 1",
                                    },
                                  })}
                                  onKeyDown={(e) => {
                                    if (
                                      e.key === "-" || // Prevent negative sign
                                      e.key === "+" || // Prevent plus sign
                                      e.key === "e" || // Prevent scientific notation
                                      e.key === "E" || // Prevent scientific notation
                                      e.key === "." || // Prevent decimal point (if only integers allowed)
                                      (isNaN(Number(e.key)) &&
                                        e.key !== "Backspace" &&
                                        e.key !== "Tab") // Allow only numbers, Backspace, and Tab
                                    ) {
                                      e.preventDefault();
                                    }
                                  }}
                                  onPaste={(e) => {
                                    const pasteData =
                                      e.clipboardData.getData("text");
                                    if (!/^\d+$/.test(pasteData)) {
                                      // Allow only numbers in pasted data
                                      e.preventDefault();
                                    }
                                  }}
                                />
                              </InputGroup>
                              {errors.per_car_price && (
                                <span className="text-danger">
                                  {errors.per_car_price.message}
                                </span>
                              )}
                            </Form.Group>
                          </Row>
                        </div>
                      </Col>
                      <Col lg={6}>
                        <div className="main-form-section mt-3">
                          <Row className="justify-content-start">
                            <Form.Label className="text-left">Image</Form.Label>

                            <Form.Group>
                              <Form.Control
                                className={classNames("", {
                                  "is-invalid": errors?.image,
                                })}
                                type="file"
                                {...register("image", {
                                  required: "Image is required",
                                  validate: async (value) => {
                                    if (typeof value !== "string") {
                                      const fileTypes = ["jpg", "png", "jpeg"];
                                      const fileType =
                                        value[0].name?.split(".")[1];

                                      if (!fileTypes.includes(fileType)) {
                                        return `please upload a valid file format. (${fileTypes})`;
                                      }

                                      const sizes = await getDimension(
                                        value[0]
                                      );
                                      // if (
                                      //   sizes.width !== 1296 &&
                                      //   sizes.height !== 465
                                      // ) {
                                      //   return "Image width and height must be 1296 px and 465 px";
                                      // }

                                      // const fileSize = Math.round(
                                      //   value[0].size / 1024
                                      // );
                                      // if (fileSize > 500) {
                                      //   return "file size must be lower than 500kb";
                                      // }
                                    }
                                  },
                                })}
                                accept=".jpg, .jpeg, .png"
                              />
                            </Form.Group>
                            {errors.image && (
                              <span className="text-danger">
                                {errors.image.message}
                              </span>
                            )}
                          </Row>
                        </div>
                      </Col>

                      <Col className="main-form-section mt-3">
                        <div className="main-form-section mt-3">
                          <Row className="justify-content-center">
                            <Form.Label>Image Preview</Form.Label>

                            {imageFile && imageFile?.length > 0 && (
                              <div className="image-preview-container mt-3">
                                <img
                                  // src={URL.createObjectURL(getValues("image")[0])}
                                  src={URL?.createObjectURL(imageFile[0])}
                                  alt="Preview"
                                  className="image-preview"
                                  style={{ width: "200px", height: "200px" }}
                                />
                              </div>
                            )}
                          </Row>
                        </div>
                      </Col>

                      <Col lg={12}>
                        <div className="main-form-section mt-3">
                          <Row className="justify-content-start">
                            <Col sm={12}>
                              <Form.Label className="text-center">
                                Description
                              </Form.Label>
                              <Form.Group>
                                <Controller
                                  name="description"
                                  control={control}
                                  rules={{
                                    required: "Description is required.",
                                  }}
                                  render={({ field }) => (
                                    <JoditEditor
                                      value={field.value || ""} // correct binding
                                      onBlur={(newContent) => {
                                        setValue("description", newContent);
                                        trigger("description");
                                      }}
                                    />
                                  )}
                                />
                              </Form.Group>
                              {errors.description && (
                                <span className="text-danger">
                                  {errors.description.message}
                                </span>
                              )}
                            </Col>
                          </Row>
                        </div>
                      </Col>

                      <div className="main-form-section mt-5"></div>
                      <Card.Title>
                        Package Details
                        {quantityError && (
                          <div className="text-danger">{quantityError}</div>
                        )}
                      </Card.Title>
                      <hr />

                      {dayFields.map((variant, index) => (
                        <div key={variant.id} className="main-form-section mt-3 p-3 border rounded">
                          {/* ── Day header ─────────────────────────────────────────────────── */}
                          <div className="d-flex align-items-center justify-content-between mb-2">
                            <h6 className="mb-0 fw-bold text-primary">Detail {index + 1}</h6>
                            {dayFields.length > 1 && (
                              <button
                                type="button"
                                className="btn btn-sm btn-danger"
                                onClick={() => removeDay(index)}
                              >
                                Remove Detail
                              </button>
                            )}
                          </div>

                          <Row>
                            <Col md={6}>
                              <div className="main-form-section mt-3">
                                <Row className="justify-content-center">
                                  <Form.Label>
                                    Package Detail Type <span className="text-danger">*</span>
                                  </Form.Label>
                                  <Form.Group>
                                    <Controller
                                      name="detail_type_id"
                                      {...register(`packages_detail.${index}.detail_type_id`, {
                                        required: "Select Package Detail Type",
                                      })}
                                      control={control}
                                      render={({ field }) => {

                                        return (
                                          <Select
                                            className="text-dark"
                                            styles={{
                                              control: (baseStyles) => ({
                                                ...baseStyles,
                                                borderColor: errors.detail_type_id
                                                  ? "red"
                                                  : baseStyles,
                                              }),
                                            }}
                                            {...field}
                                            options={getFilteredOptions(index)}

                                          />
                                        )
                                      }
                                      }
                                    />
                                    {errors?.packages_detail?.[index]?.detail_type_id && (
                                      <span className="text-danger small">
                                        {errors.packages_detail[index].detail_type_id.message}
                                      </span>
                                    )}
                                  </Form.Group>
                                </Row>
                              </div>
                            </Col>

                            <Col lg={12}>
                              <DayDescriptions
                                dayIndex={index}
                                control={control}
                                setValue={setValue}
                                trigger={trigger}
                                errors={errors}
                              />
                            </Col>

                            {/* <Col lg={12}>
                              <div className="main-form-section mt-3">
                                <Form.Label>
                                  Images{" "}
                                  <span className="text-muted small">(add as many as needed)</span>
                                </Form.Label>

                            <input
                              type="file"
                              accept="image/*"
                              multiple
                              style={{ display: "none" }}
                              ref={(el) => (fileInputRefs.current[index] = el)}
                              onChange={(e) => handleImageAdd(index, e)}
                            />

                            <div className="mb-2">
                              <button
                                type="button"
                                className="btn btn-outline-primary btn-sm"
                                onClick={() => fileInputRefs.current[index]?.click()}
                              >
                                + Add Images
                              </button>
                            </div>

                            <Controller
                              name={`packages_detail.${index}.images`}
                              control={control}
                              defaultValue={[]}
                              rules={{
                                // validate: (val) =>
                                //   (val && val.length > 0) || "At least one image is required",
                              }}
                              render={({ field }) => (
                                <>
                                  {field.value && field.value.length > 0 ? (
                                    <Row className="g-2 mt-1">
                                      {field.value.map((img, imgIndex) => (
                                        <Col
                                          key={imgIndex}
                                          xs={6}
                                          sm={4}
                                          md={3}
                                          lg={2}
                                          className="position-relative"
                                        >
                                          <div
                                            style={{
                                              position: "relative",
                                              width: "100%",
                                              paddingTop: "100%", // square
                                              borderRadius: 8,
                                              overflow: "hidden",
                                              border: "1px solid #dee2e6",
                                            }}
                                          >
                                            <img
                                              src={
                                                img.preview ||
                                                // support already-saved URL strings
                                                (typeof img === "string" ? img : "")
                                              }
                                              alt={`day-${index + 1}-img-${imgIndex + 1}`}
                                              style={{
                                                position: "absolute",
                                                top: 0,
                                                left: 0,
                                                width: "100%",
                                                height: "100%",
                                                objectFit: "cover",
                                              }}
                                            />
                                            <button
                                              type="button"
                                              onClick={() =>
                                                handleImageRemove(index, imgIndex)
                                              }
                                              style={{
                                                position: "absolute",
                                                top: 4,
                                                right: 4,
                                                background: "rgba(220,53,69,0.85)",
                                                border: "none",
                                                borderRadius: "50%",
                                                width: 22,
                                                height: 22,
                                                color: "#fff",
                                                fontSize: 12,
                                                lineHeight: "22px",
                                                textAlign: "center",
                                                cursor: "pointer",
                                                padding: 0,
                                              }}
                                            >
                                              ✕
                                            </button>
                                          </div>
                                          <p
                                            className="text-muted text-center mt-1"
                                            style={{ fontSize: 10, wordBreak: "break-all" }}
                                          >
                                            {img.file?.name ?? `Image ${imgIndex + 1}`}
                                          </p>
                                        </Col>
                                      ))}
                                    </Row>
                                  ) : (
                                    <p className="text-muted small mt-1">
                                      No images added yet.
                                    </p>
                                  )}
                                </>
                              )}
                            />

                            {errors?.packages_detail?.[index]?.images && (
                              <span className="text-danger small d-block mt-1">
                                {errors.packages_detail[index].images.message}
                              </span>
                            )}
                        </div>
                            </Col> */}
                          </Row>
                        </div>
                      ))}

                      <div className="main-form-section mt-3"></div>
                      <hr />
                      <div className="text-center">
                        <button
                          type="button"
                          className="btn btn-primary mb-3"
                          onClick={() => appendDay(emptyDay())}
                        >
                          + Add Detail
                        </button>
                      </div>

                      <Row className="mt-5 pb-3">
                        <div className="d-flex justify-content-center">
                          <Link>
                            <CancelButton
                              name={"cancel"}
                              handleClose={props.handleClose}
                            />
                          </Link>

                          <Button
                            name={"save"}
                            onClick={handleSubmit(onSubmit)}
                            type="button"
                            className="btn btn-primary mb-3"
                          >
                            <FontAwesomeIcon
                              icon="fa-solid fa-floppy-disk"
                              className="me-2"
                            />
                            save
                          </Button>

                          {/* <Button
                            name={"next"}
                            type="button"
                            className="save-btnnnnnn me-2"
                          >
                            <FontAwesomeIcon
                              icon="fa-solid fa-floppy-disk"
                              className="me-2"
                            />
                            Next
                          </Button> */}
                        </div>
                      </Row>

                      <hr />
                      {/* <MultiVarientMain /> */}
                    </Row>
                  </Form>
                </Container>
              </Card.Body>
            </Card>
          </Offcanvas.Body >
        </Offcanvas >

        <ModalSave
          message={showModal.message}
          showErrorModal={showModal.code ? true : false}
        />
      </div >
    </>
  );
};

export default AddOffCanvance;
